

  //  CART PRODUCT RECOMMENDATIONS —





// old code 
// let loadedForProduct = null;
// let lastCartHTML = "";
// let observerStarted = false;

// function getCartRoot() {
//   return document.querySelector(".cart-drawer, #CartDrawer, cart-drawer");
// }

// function loadRecommendationsOnce() {
//   const cart = getCartRoot();
//   if (!cart) return;

//   const wrapper = cart.querySelector(".js-cart-recommendations-wrapper");
//   if (!wrapper) return;

//   const productId = wrapper.dataset.productId;
//   if (!productId) return;

//   //  Already loaded for this product
//   if (loadedForProduct === productId) return;

//   loadedForProduct = productId;

//   fetch(
//     `/recommendations/products?section_id=cart-product-recommendations&product_id=${productId}&limit=6`
//   )
//     .then(r => r.text())
//     .then(html => {
//       const doc = new DOMParser().parseFromString(html, "text/html");
//       const section = doc.querySelector(".cart-recommendations");
//       if (!section) return;

//       wrapper.innerHTML = "";
//       wrapper.appendChild(section);

//       initCartRecommendationSlider();
//     });
// }

// /* ----------------------------------------
//    SLIDER
// ---------------------------------------- */
// function initCartRecommendationSlider() {
//   const section = document.querySelector(".cart-recommendations");
//   if (!section) return;

//   const slider = section.querySelector(".cart-recommendations__slider");
//   const prev = section.querySelector(".cart-rec-arrow.left");
//   const next = section.querySelector(".cart-rec-arrow.right");

//   if (!slider || !prev || !next) return;

//   /* ================================
//       NEW: Arrow fade logic (VISUAL ONLY)
//   ================================ */
//   function updateArrowFade() {
//     const maxScroll = slider.scrollWidth - slider.clientWidth;

//     prev.classList.toggle("is-faded", slider.scrollLeft <= 1);
//     next.classList.toggle(
//       "is-faded",
//       slider.scrollLeft >= maxScroll - 1
//     );
//   }

//   /* ----------------------------------------
//      SHOW / HIDE ARROWS (UNCHANGED)
//   ---------------------------------------- */
//   const updateArrows = () => {
//     const canScroll = slider.scrollWidth > slider.clientWidth + 1;

//     if (canScroll) {
//       prev.style.display = "flex";
//       next.style.display = "flex";
//     } else {
//       prev.style.display = "none";
//       next.style.display = "none";
//     }

//     //  NEW: keep fade state in sync
//     updateArrowFade();
//   };

//   updateArrows();
//   window.addEventListener("resize", updateArrows);

//   const card = slider.querySelector(".cart-recommendations__item");
//   if (!card) return;

//   const scroll = card.offsetWidth + 14;

//   /* ----------------------------------------
//      EXISTING ARROW HANDLERS (UNCHANGED)
//   ---------------------------------------- */
//   prev.onclick = () => {
//     slider.scrollBy({ left: -scroll, behavior: "smooth" });

//     setTimeout(updateArrowFade, 350); // 🔹 NEW
//   };

//   next.onclick = () => {
//     slider.scrollBy({ left: scroll, behavior: "smooth" });

//     setTimeout(updateArrowFade, 350); // 🔹 NEW
//   };

//   /* ----------------------------------------
//       NEW: sync with touch / momentum scroll
//   ---------------------------------------- */
//   slider.addEventListener("scroll", () => {
//     requestAnimationFrame(updateArrowFade);
//   });
// }

// /* ----------------------------------------
//    CART OBSERVER (SAFE)
// ---------------------------------------- */
// function observeCartDrawer() {
//   if (observerStarted) return;
//   observerStarted = true;

//   const body = document.body;

//   const observer = new MutationObserver(() => {
//     const cart = getCartRoot();
//     if (!cart) return;

//     const html = cart.innerHTML;

//     // Only react to REAL cart rebuilds
//     if (html !== lastCartHTML) {
//       lastCartHTML = html;
//       loadedForProduct = null;
//       loadRecommendationsOnce();
//     }
//   });

//   observer.observe(body, {
//     childList: true,
//     subtree: true
//   });
// }

// /* ----------------------------------------
//    START
// ---------------------------------------- */
// observeCartDrawer();
// loadRecommendationsOnce();




// to show arrow on slider 
(function () {
  function initCartRecommendationSlider() {
    const section = document.querySelector(".cart-recommendations");
    if (!section) return;

    const slider = section.querySelector(".cart-recommendations__slider");
    if (!slider) return;

    function updateFade() {
      const prev = section.querySelector(".cart-rec-arrow.left");
      const next = section.querySelector(".cart-rec-arrow.right");
      if (!prev || !next) return;

      const maxScroll = slider.scrollWidth - slider.clientWidth;

      prev.classList.toggle("is-faded", slider.scrollLeft <= 1);
      next.classList.toggle(
        "is-faded",
        slider.scrollLeft >= maxScroll - 1
      );
    }

    function updateVisibility() {
      const prev = section.querySelector(".cart-rec-arrow.left");
      const next = section.querySelector(".cart-rec-arrow.right");
      if (!prev || !next) return;

      const canScroll = slider.scrollWidth > slider.clientWidth + 2;
      prev.style.display = canScroll ? "flex" : "none";
      next.style.display = canScroll ? "flex" : "none";

      updateFade();
    }

    const card = slider.querySelector(".cart-recommendations__item");
    if (!card) return;

    const gap = 14;
    const scrollAmount = card.offsetWidth + gap;

    /* ----------------------------------
       EVENT DELEGATION (KEY FIX)
    ---------------------------------- */
    section.onclick = (e) => {
      const prev = e.target.closest(".cart-rec-arrow.left");
      const next = e.target.closest(".cart-rec-arrow.right");

      if (prev) {
        slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        setTimeout(updateFade, 300);
      }

      if (next) {
        slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
        setTimeout(updateFade, 300);
      }
    };

    slider.onscroll = () => {
      requestAnimationFrame(updateFade);
    };

    window.onresize = updateVisibility;

    updateVisibility();
  }

  /* ----------------------------------
     OBSERVE CART DOM CHANGES (LIGHT)
  ---------------------------------- */
  const observer = new MutationObserver(() => {
    initCartRecommendationSlider();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener("DOMContentLoaded", () => {
    initCartRecommendationSlider();
  });
})();
